import React, { useState } from "react";

const ContentTab = ({ handleLayoutChange, selectedLayout,updateCookieConsentTabData,cookieConsentTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [complianceType, setComplianceType] = useState(cookieConsentTabData.compliance_type);
    const [languageType, setLanguageType] = useState(cookieConsentTabData.language_type);
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
    const [message, setMessage] = useState(cookieConsentTabData.message);
    const [policyDisplayType, setPolicyDisplayType] = useState(cookieConsentTabData.policy_display_type);
    const [policyUrl, setPolicyUrl] = useState(cookieConsentTabData.policy_url);
    const [policyLinkText, setPolicyLinkText] = useState(cookieConsentTabData.policy_link_text);
    const [allowButtonText, setAllowButtonText] = useState(cookieConsentTabData.allow_button_text);
    const [declineButtonText, setDeclineButtonText] = useState(cookieConsentTabData.decline_button_text);
    const [showCookieIcion, setShowCookieIcion] = useState(Number(cookieConsentTabData.is_show_cookie_icon));
    const [showConfirmationButton, setShowConfirmationButton] = useState(Number(cookieConsentTabData.is_show_confirmation_button));
    const [confirmationButtonText, setConfirmationButtonText] = useState(cookieConsentTabData.confirmation_button_text);
 
    // Handlers Compliance Type Change
    const handleComplianceTypeChange = (event) => {
        const value = event.target.value;
        setComplianceType(value);
        updateCookieConsentTabData("compliance_type", value);
    };

    // Handlers Language Type Change
    const handleLanguageChange = (lang) => {
        setLanguageType(lang);
        updateCookieConsentTabData(prev => ({
            ...prev,
            language_type: lang
        }));
        setLanguageDropdownOpen(false);
    };

    // Handlers Message Change
    const handleMessageChange = (event) => {
        const value = event.target.value;
        setMessage(value);
        updateCookieConsentTabData("message", value);
    };

    // Handlers Policy Display Type Change
    const handlePolicyDisplayTypeChange = (event) => {
        const value = event.target.value;
        setPolicyDisplayType(value);
        updateCookieConsentTabData("policy_display_type", value);
    };

    // Handlers Policy Url Change
    const handlePolicyUrlChange = (event) => {
        const value = event.target.value;
        setPolicyUrl(value);
        updateCookieConsentTabData("policy_url", value);
    };

    // Handlers Policy Link Text Change
    const handlePolicyLinkTextChange = (event) => {
        const value = event.target.value;
        setPolicyLinkText(value);
        updateCookieConsentTabData("policy_link_text", value);
    };

    // Handlers Allow Button Text Change
    const handleAllowButtonTextChange = (event) => {
        const value = event.target.value;
        setAllowButtonText(value);
        updateCookieConsentTabData("allow_button_text", value);
    };

    // Handlers Decline Link Text Change
    const handleDeclineButtonTextChange = (event) => {
        const value = event.target.value;
        setDeclineButtonText(value);
        updateCookieConsentTabData("decline_button_text", value);
    };

    //Handlers Show Cookie Icon Change
    const handleShowCookieIcionChange = (e) => {
        const checked = e.target.checked;
        setShowCookieIcion(checked);
        updateCookieConsentTabData("is_show_cookie_icon", checked); 
    };

    //Handlers Show Confirmation Button Change
    const handleConfirmationButtonChange = (e) => {
        const checked = e.target.checked;
        setShowConfirmationButton(checked);
        updateCookieConsentTabData("is_show_confirmation_button", checked); 
    };

    // Handlers Confirmation Button Text Change
    const handleConfirmationButtonTextChange = (event) => {
        const value = event.target.value;
        setConfirmationButtonText(value);
        updateCookieConsentTabData("confirmation_button_text", value);
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                    <div className="layout-box-all">
                        <div className="card h-100">
                            <div className="name-tile-row px-2">Compliance Type</div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row pt-0">
                                    <ul>
                                        <li>
                                            <div className="form-group">
                                                <input id="compliance_type1" type="radio" name="compliance_type" value="Show_Allow_Cookies" onChange={handleComplianceTypeChange} checked={complianceType === 'Show_Allow_Cookies'}  />
                                                <label for="compliance_type1" className="d-flex">Just tell users that you use cookies</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-group">
                                                <input id="compliance_type2" type="radio" name="compliance_type"  value="Hide_Allow_Cookies" onChange={handleComplianceTypeChange} checked={complianceType === 'Hide_Allow_Cookies'}/>
                                                <label for="compliance_type2" className="d-flex">Ask users to opt into cookies</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div> 
                            </div>

                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <span>Language</span>
                                    <div className="color-pikr-box" onClick={() => setLanguageDropdownOpen(!languageDropdownOpen)}>
                                        <em>{languageType}</em>
                                        {languageDropdownOpen && (
                                            <ul className="dropdown-list">
                                                {["English"].map((lang) => (
                                                    <li key={lang} onClick={() => handleLanguageChange(lang)}>
                                                        {lang}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("message")}>Message <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("policy")}>Policy <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            {complianceType === 'Show_Allow_Cookies' && (
                            <>
                                <li>
                                    <button onClick={() => setActiveSettingElementsTab("buttons")}>Buttons <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                                </li>
                            </>
                            )}
                            {complianceType === 'Hide_Allow_Cookies' && (
                            <>
                                <li>
                                    <button onClick={() => setActiveSettingElementsTab("confirmation_button")}>Confirmation Button <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                                </li>
                            </>
                            )}

                            <li>
                                <button onClick={() => setActiveSettingElementsTab("cookie_icon")}>Cookie Icon <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "message" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Message</span>
                        {/* <div className="name-tile-row">Message</div> */}
                        <div className="side-baar-box-header">
                            <div className="box-header-row welcome-message">
                                <textarea value={message} onChange={handleMessageChange} placeholder="Type Message..." defaultValue="We use cookie to improve your experience on our site. By using our site you consent cookies."></textarea>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "policy" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Policy</span>
                        <div className="side-baar-box-header">
                            <div className="name-tile-row">Policy Display</div>
                            <div className="side-baar-box-header">
                                <div className="box-header-row">
                                    <ul>
                                        <li>
                                            <div className="form-group">
                                                <input id="policy_display_type1" type="radio" name="policy_display_type" value="Show_Policy_link" onChange={handlePolicyDisplayTypeChange} checked={policyDisplayType === 'Show_Policy_link'} />
                                                <label for="policy_display_type1">Link to your own policy</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-group">
                                                <input id="policy_display_type2" type="radio" name="policy_display_type"  value="Dont_Show_Policy_link" onChange={handlePolicyDisplayTypeChange} checked={policyDisplayType === 'Dont_Show_Policy_link'}/>
                                                <label for="policy_display_type2">Don’t show policy link</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div> 
                                {cookieConsentTabData.policy_display_type === "Show_Policy_link" && (
                                    <>
                                        <div className="name-tile-row">Your Policy Url</div>
                                        <div className="side-baar-box-header">
                                            <div className="box-header-row bubble-text">
                                                <input type="text" value={policyUrl} onChange={handlePolicyUrlChange}  placeholder="Enter Policy Url" />
                                            </div>
                                        </div>
                                        <div className="name-tile-row">Policy Link Text</div>
                                        <div className="side-baar-box-header">
                                            <div className="box-header-row bubble-text">
                                                <input type="text" value={policyLinkText} onChange={handlePolicyLinkTextChange} placeholder="Enter Policy Link Text" />
                                            </div>
                                        </div>
                                    </>
                                )}
                                <p className="p-tag-padding">You can add a link to your Cookie Policy to your widget after the cookie consent message.</p>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "buttons" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Buttons</span>
                        <div className="side-baar-box-header">
                            <div className="name-tile-row">Allow Button Text</div>
                            <div className="box-header-row bubble-text">
                                <input type="text" value={allowButtonText} onChange={handleAllowButtonTextChange}  placeholder="Enter Allow Button Text" />
                            </div>
                            <div className="name-tile-row">Decline Button Text</div>
                            <div className="box-header-row bubble-text">
                                <input type="text" value={declineButtonText} onChange={handleDeclineButtonTextChange} placeholder="Enter Decline Button Text" />
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "confirmation_button" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Confirmation Button</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Show Confirmation Button</span>
                                <div className="form-group">
                                    <input id="open_is_show_confirmation_button" className="chkbx-toggle" type="checkbox" checked={showConfirmationButton} onChange={handleConfirmationButtonChange} />
                                    <label for="open_is_show_confirmation_button"></label>
                                </div>
                            </div>
                            {Number(cookieConsentTabData.is_show_confirmation_button) === 1 && (
                            <>
                                <div className="name-tile-row">Confirmation Button Text</div>
                                <div className="box-header-row bubble-text">
                                    <input type="text" value={confirmationButtonText} onChange={handleConfirmationButtonTextChange} placeholder="Enter Confirmation Button Text" />
                                </div>
                            </>
                            )}
                        </div> 
                    </div>
                </>
            )}

            {activeSettingElementsTab === "cookie_icon" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Cookie Icon</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row"><span>Cookie Icon</span>
                                <div className="form-group">
                                    <input id="open_is_show_cookie_icon" className="chkbx-toggle" type="checkbox" checked={showCookieIcion} onChange={handleShowCookieIcionChange} />
                                    <label for="open_is_show_cookie_icon"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ContentTab;